import { Button } from '@efexteam/components';
import RefreshIcon from '@mui/icons-material/Refresh';
import { Grid, TextField, Typography } from '@mui/material';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useApiCall } from 'use-api-call';
import authSvc from '@efex-services/auth/authSvc';

interface DisableProps {
  goBack: () => void;
  nextStep: () => void;
}

const Disable = ({ goBack, nextStep }: DisableProps) => {
  const { t } = useTranslation();
  const [authCode, setAuthCode] = useState('');

  const {
    data,
    invoke: disable2Fa,
    loading,
    error,
  } = useApiCall(() =>
    authSvc.disable2Fa({
      otp: authCode,
    })
  );

  const allowOnlyNumber = (value: string) => value.replace(/\D/g, '');

  useEffect(() => {
    if (data) {
      nextStep();
    }
  }, [data, nextStep]);

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Typography variant="h6">{t('tfDisableTitle')}</Typography>
        <Typography variant="subtitle1">{t('tfDisableSubtitle')}</Typography>
        <Typography variant="body2" className="!my-5">
          {t('tdDisableDescription')}
        </Typography>
        <TextField
          type="text"
          label={t('tfAuthCodeInput')}
          variant="outlined"
          className="w-full !my-3"
          value={authCode}
          error={!!error}
          helperText={error ? t('tfConfirmationCodeError') : undefined}
          onChange={(e) =>
            setAuthCode(allowOnlyNumber(e.target.value).slice(0, 6))
          }
        />
        <div className="flex justify-around gap-3">
          <Button
            appearance="secondary"
            disabled={loading}
            variant="outlined"
            onClick={goBack}
          >
            {t('back')}
          </Button>
          <Button
            appearance="primary"
            onClick={disable2Fa}
            startIcon={
              loading ? <RefreshIcon className="animate-spin" /> : null
            }
            disabled={!authCode || authCode.length < 6 || loading}
          >
            {t('tdDisableConfirmation')}
          </Button>
        </div>
      </Grid>
    </Grid>
  );
};

export default Disable;
